import React, { Component } from "react";
import ReactMapboxGl from "react-mapbox-gl";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Markers from "./Markers";

const Map = ReactMapboxGl({
  accessToken:
    "pk.eyJ1IjoiY29kZW5zbyIsImEiOiJja2g1NXlhcG0wNXVhMnpuejV0NnhhazNqIn0._9yBwBleFKLWeSo_Lbrj0w",
});
class PimaMap extends Component {
  render() {
    const { zoom, center } = this.props;
    return (
      <>
        <Map
          // eslint-disable-next-line
          style={"mapbox://styles/mapbox/streets-v10"}
          center={center}
          zoom={zoom}
          containerStyle={{
            height: "91vh",
            width: "100%",
          }}
        >
          <Markers />
        </Map>
        <div className="map-footer">
          Made by: <a href="https://techventuresusa.com">Tech Ventures</a>
        </div>
      </>
    );
  }
}

PimaMap.propTypes = {
  zoom: PropTypes.array.isRequired,
  center: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  zoom: state.testcenter.zoom,
  center: state.testcenter.center,
});

export default connect(mapStateToProps)(PimaMap);
